mobileSize = 800;

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 800) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 801) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Feature Lineup Module
  $('.featureLineup-headline').removeClass('button');
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});